import DescriptionItem from "./DescriptionItem";


const Description = ({ R1, R2, R3, R4, R5, Networth }) => {
    const networthStr = Networth.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
const networthNoDecimal = Networth.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return (
        <div className="space-y-6">
            <div className="space-y-2">
                {
                    R1 ? <DescriptionItem falseText={"You have too much debt, which is considered risky to lenders."} rightText={"You have manageable amount of debt compared to your income."} condition={R1 <= 40} /> : null
                }
                {
                    R2 ? <DescriptionItem falseText={"You have less than 3 months of savings to cover your expenses and debt obligations."} rightText={"You have 3+ months of savings to cover expenses and debt payments. Maintain this as your emergency fund."} condition={R2 > 300} /> : null
                }
                {
                    R3 ? <DescriptionItem falseText={"You have a negative networth."} rightText={"You have positive networth."} condition={R3 >= 100} /> : null
                }
                {
                    R4 ? <DescriptionItem falseText={"Your savings are not enough to cover essential payments. You need to boost your savings' value."} rightText={`Your savings can be liquidated to cover ${(Number(R4)/100).toFixed(0)} months of payments. 6 months or more is a good sign.  `} condition={R4 > 1} /> : null
                }
                {
                    R5 ? <DescriptionItem falseText={"Your housing cost is high compared to your income."} rightText={`Your housing cost is manageable with your current income.`} condition={R5 <= 30} /> : null
                }
            </div>
            <div>
                <h1 className="font-bold text-xl"><span className="text-chinese-black">Your Net Worth is:</span> <span className="text-jungle-green"> {'$'+(networthNoDecimal)}</span></h1>
            </div>
        </div >
    );
};

export default Description;;;;